<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user-settings__top">
        <div class="user-settings__profil" style="width: 100%;display: flex; justify-content: space-between;">
          <div class="left-one" style="display: flex; align-items: center;">
            <div class="left">
              <img src="@/assets/img/campuscity-logo.png" alt="" class="user-settings__profil-img"></div>
            <div class="right" style="margin-left: -45px;"><p class="user-settings__profil-name">
              Welcome ! </p>
              <p class="user-settings__profil-mail">
                {{username}}
              </p></div>
          </div>
          <div class="right">
            <p class="user-settings__profil-name mail">
              {{mail}}
              <span class="sign-out">
                <svg class="icon"><use
                  xlink:href="/icon/icons.svg#icon-mail"></use>
                </svg>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="user__list-offer" style="margin-top: 40px;">
        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">YURT BİLGİLERİ</div>
          <div class="register-box_input">
            <v-input placeholder="Yurt Şube Adı" v-model="dorm.name"/>
            <label for="password" v-if="emptyName" class="myValidationText">Bu kısım boş geçilemez!</label> 
            <div class="groups">
              <VueSelectTempCity :options="cities" placeholder="Şehir Seçiniz" v-model="dorm.city_id" style="font-weight: bold" @onselect="selectCity" />
              <VueSelectTempDistrict :options="districts" placeholder="İlçe Seçiniz" @onselect="selectDistrict"/>
              <VueSelectTempGender class="big-select" :options="genders" placeholder="Yurt Tipi" style="width: 225%;margin-right: 0;" v-model="dorm.dorm_type_id" @onselect="selectGender" />
            </div>

            <div class="groups">
              <v-input placeholder="E-Posta Adresiniz" style="width: 47%" v-model="dorm.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label> 
              <v-input placeholder="Telefon" style="width: 47%" v-model="dorm.phone"/>
             <label for="phone" v-if="emptyPhone2" class="myValidationText">Bu kısım boş geçilemez!</label>
             <label for="phone" v-if="falsePhone2" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone2" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>              
            </div>
            <v-input placeholder="Adres" v-model="dorm.address"/>
          <label for="password" v-if="emptyAddress" class="myValidationText">Bu kısım boş geçilemez!</label>  
          <v-input placeholder="Mesaj İçin Telefon" style="width: 47%" v-model="dorm.message_phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label> 
        <v-input placeholder="Web Adresi" style="width: 47%" v-model="web"/>
          </div>
        </div>

        <div class="register-box__info col-xl-12">
          <div class="or blue">
            <p class="or__title-blue">YETKİLİ BİLGİLERİ</p>
          </div>
          <v-input placeholder="Yurt Yetkilisi" v-model="dorm.member"/>
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Yetkili E-Posta" v-model="dorm.member_email"/>
            </div>

            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Yetkili Telefon" v-model="dorm.mobile_phone"/>
             <label for="phone" v-if="emptyPhone3" class="myValidationText">Bu kısım boş geçilemez!</label>
             <label for="phone" v-if="falsePhone3" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
             <label for="phone" v-if="shortPhone3" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>               
            </div>
          </div>
        </div>

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">ÖZET BİLGİLER</div>
          <div class="register-box_input">
            <v-input placeholder="Türkçe Açıklama" class="textarea" v-html="dorm.content"/>
            <v-input placeholder="İngilizce Açıklama" class="textarea" v-html="dorm.content_en"/>
            <div class="groups">
              <!-- <v-select :options="days" placeholder="Kapasite" v-model="capacity" style="font-weight: bold"/> -->
              <v-input placeholder="Kapasite" v-model="dorm.capacity"/>
              <label for="password" v-if="emptyCapacity" class="myValidationText">Bu kısım boş geçilemez!</label>
              <VueSelectTempMeal :options="meals" placeholder="Yemek Hizmeti" @onselect="selectMeal" v-model="dorm.meal"/>
              <label for="password" v-if="emptyMeal" class="myValidationText">Bu kısım boş geçilemez!</label>
              <VueSelectTempWifi :options="wifi" placeholder="WIFI Seçeneği" style="width: 225%;margin-right: 0;" @onselect="selectWifi" v-model="dorm.is_wifi"/>
              <label for="password" v-if="emptyWifi" class="myValidationText">Bu kısım boş geçilemez!</label>
            </div>
          </div>
        </div>

<!--         <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">ODA TİPLERİ</div>
          <div class="room-type">
              <my-dorm-room-type/>
          </div>
        </div> -->

        <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">HİZMET VE ÖZELLİKLER</div>
<!--           <div class="room-type">
            <div >
              <MyDormBuildingServices/>
            </div>
          </div>
          <div class="room-type">
            <div >
              <my-dorm-room-services/>
            </div>
          </div> -->
          <div class="room-type">
            <div >
              <MyDormServices :bina="bina" :oda="oda" :hizmetler="hizmetler"/>
            </div>
          </div>             
        </div>
      </div>


        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">LOKASYON BİLGİLERİ</div>
          <div class="register-box_input">
            <v-input placeholder="Enlem" class="textarea" v-model="dorm.lat"/>
            <v-input placeholder="Boylam" class="textarea" v-model="dorm.lng"/>
          </div>
        </div> 

<!--         <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">DİĞER BİLGİLER</div>
          <div class="register-box_input">
            <v-input placeholder="Tesisler" class="textarea" v-model="facilities"/>
            <v-input placeholder="Avantajlar" class="textarea" v-model="advantages"/>
            <v-input placeholder="Etkinlikler" class="textarea" v-model="events"/>
            <v-input placeholder="Ulaşım" class="textarea" v-model="transportation"/>
            <v-input placeholder="Diğer" class="textarea" v-model="advantages"/>                
          </div>
        </div> -->
        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">MULTIMEDIA</div>
          <div class="register-box_input">
              <v-select class="big-select" :options="videotypes" placeholder="Video Tipi" style="width: 25%;margin-right: 0;" v-model="type_id" @onselect="selectVideo" />            
            <v-input placeholder="Video Url" class="textarea" v-model="video_url"/>
            <v-input placeholder="Sanal Tur" class="textarea" v-model="virtual_tour"/>
          </div>
        </div> 

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">META BİLGİLERİ</div>
          <div class="register-box_input">
            <v-input placeholder="Açıklama" class="textarea" v-model="dorm.description"/>
            <v-input placeholder="Anahtar Kelimeler" class="textarea" v-model="dorm.keywords"/>
          </div>
        </div>

<div>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>
        <!--//components-->
        <MyDormGaleri :gallery="images"/>
        <!--//components-->
<div>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>        
        <div class="branch-add mywidth" v-on:click="saveDorm()" v-if="messageEnabled">
          <button class="branch-add__button">
            <p class="branch-add__txt">KAYDET</p>
            <span class="branch-add__icon">
              <svg-icon type="icon-plus"/>
            </span>
          </button>        
        </div>
        <div class="branch-add mywidth" v-if="!messageEnabled">
          <button class="branch-add__button">
            <p class="branch-add__txt">KAYDEDİYOR</p>
            <span class="branch-add__icon">
              <svg-icon type="icon-plus"/>
            </span>
          </button>        
        </div>        
    </container>
   <div>
   </div>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >YURT GÜNCELLENDİ!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Şube bilgileriniz güncellenmiştir.</span></p>
      <!-- <p ><span class= "mycolorBlue">Arkadaşlarımız en yakın zamanda sizinle iletişime geçecek.</span></p> -->
    </div>
     </div>
</div>
</Modal2>
<Modal2 :active="showErrorMessage" @onModalClose="closeModal3">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title2" >YURT GÜNCELLENEMEDİ!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Malesef şu anda yurt güncellenemedi.</span></p>
      <p ><span class= "mycolorBlue">Lütfen daha sonra tekrar deneyin.</span></p>
    </div>
     </div>
</div>
</Modal2>   
  </div>
</template>

<script>
import MyDormGaleri from '@/components/MyDormGaleri2'
//import MyDormRoomType from '@/components/MyDormRoomType'
import MyDormServices from '@/components/MyDormServices'
import VueSelectTempWifi from '@/components/VueSelectTempWifi'
import VueSelectTempMeal from '@/components/VueSelectTempMeal'
import VueSelectTempCity from '@/components/VueSelectTempCity'
import VueSelectTempDistrict from '@/components/VueSelectTempDistrict'
import VueSelectTempGender from '@/components/VueSelectTempGender'
import Modal2 from '@/components/Modal2'
import axios from 'axios'
export default {
  name: 'DormUserDormUpdate',
  components: {
    MyDormGaleri, MyDormServices, Modal2, VueSelectTempWifi, VueSelectTempMeal, VueSelectTempCity, VueSelectTempDistrict, VueSelectTempGender
  },
  data () {
    return {
            videotypes: [
        {
          name: 'Youtube',
          id: '1',
          selected: false
        },
        {
          name: 'Vimeo',
          id: '2',
          selected: false
        }
      ], 
      video_url: null,
      video_type: null,
      virtual_tour: null,
      dorm: null,
      messageEnabled: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      images: [],
      errors: [],
      bina: [
        {
          title: 'Çamaşır ve Ütü Odası',
          id: 1,
          selected: false
        },
        {
          title: 'Etüt Odası',
          id: 2,
          selected: false
        },
        {
          title: 'Asansör',
          id: 3,
          selected: false
        },
        {
          title: 'Kafeterya',
          id: 4,
          selected: false
        },
        {
          title: 'Çizim Odası',
          id: 6,
          selected: false
        },
        {
          title: 'Spor Salonu',
          id: 8,
          selected: false
        },
        {
          title: 'Hobi ve Oyun Odası',
          id: 19,
          selected: false
        }
      ],
      oda: [
        {
          title: 'Balkonlu Oda',
          id: 5,
          selected: false
        },
        {
          title: 'Mini Buzdolabı',
          id: 9,
          selected: false
        },
        {
          title: 'Klima',
          id: 10,
          selected: false
        },
        {
          title: 'Duş ve Wc',
          id: 11,
          selected: false
        },
        {
          label: 'TV ve Uydu Yayını',
          id: 12,
          selected: false
        },
        {
          title: 'Sınırsız İnternet',
          id: 13,
          selected: false
        },
        {
          title: 'Kişisel Dolap',
          id: 22,
          selected: false
        },
        {
          title: 'Çalışma Masası',
          value: 23,
          selected: false
        },
        {
          title: 'Oda Telefonu',
          id: 30,
          selected: false
        }             
      ],
      hizmetler: [
        {
          title: '24 Saat Güvenlik',
          id: 16,
          selected: false
        },
        {
          title: 'Kamera Sistemi',
          id: 17,
          selected: false
        },
        { 
          title: 'Lig TV',
          id: 18,
          selected: false
        },
        {
          title: 'Mutfak',
          id: 20,
          selected: false
        },
        {
          title: 'Ücretsiz Servis',
          id: 21,
          selected: false
        },
        {
          title: 'Sabah Kahvaltısı',
          id: 26,
          selected: false
        },
        {
          title: 'Akşam Yemeği',
          id: 27,
          selected: false
        },
        {
          title: 'Günlük Temizlik',
          id: 28,
          selected: false
        },
        {
          title: 'Haftalık Temizlik',
          id: 29,
          selected: false
        }        
      ],      
      mail: 'empty@gmail.com',
      emptyName: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      falsePhone2: false,
      shortPhone2: false,
      emptyPhone2: false,
      falsePhone3: false,
      shortPhone3: false,
      emptyPhone3: false,      
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyAddress: false,
      emptyCapacity: false,
      emptyMeal: false,
      emptyWifi: false,      
            props: [],
            //props.*: [],
            cities: [],
            districts: [],
            faculties: [],
            type_id: 1,
            city_id: null,
            district_id: null,
            name: '',
            slug: '',
            keywords: '',
            description: '',
            member:'',
            member_email: '',
            member_phone: '',
            capacity: null,
            is_wifi: null, //undefined','
            meal: null, //undefined',
            content: '',// undefined',
            content_en: '', //undefined',
            facilities:null, //undefined',
            advantages: null, //undefined',
            events:null, //undefined',
            transportation:null, //undefined',
            other:null, //undefined',
            phone: null, //regex:/(0)[0-9]{10}/|not_in:null,undefined',
            mobile_phone: '', //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            message_phone: '', //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            fax: '',
            email:'',
            web: '' , //undefined',
            address: '', //' => 'required|not_in:null,undefined',
            lat: '', //undefined',
            lng: '', //undefined',
            note: '',
            
      links: [
        {
          id: 0,
          title: 'İstatistik Özeti',
          to: '/yurtlar-istatistik'
        },
        {
          id: 1,
          title: 'Bilgilerim',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Rezervasyonlar',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Mesajlar',
          to: '/mesaj-liste'
        },
        {
          id: 4,
          title: 'Yurtlarım',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'İlanlarım',
          to: '/kullanici-favoriler'
        },
        {
          id: 6,
          title: 'Yorumlar',
          to: '/yurtlar-yorumlar'
        }
      ],
      days: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days1: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days2: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      genders: [
        {
          name: 'Erkek',
          id: '1',
          selected: false
        },
        {
          name: 'Kız',
          id: '2',
          selected: false
        }
      ],
      meals: [
        {
          name: '1 Öğün',
          id: '1',
          selected: false
        },
        {
          name: '2 öğün',
          id: '2',
          selected: false
        },
        {
          name: '3 öğün',
          id: '3',
          selected: false
        }        
      ],
      wifi: [
        {
          name: 'Wifi Var',
          id: '1',
          selected: false
        },
        {
          name: 'Wifi Yok',
          id: '2',
          selected: false
        }
      ]                    
    }
  },
  methods: {
    getDorms () {
      let self = this
      //axios.get(`/dorm/dorms`)
      const id = window.localStorage.getItem('dorm_id')
      axios.get(`/dorm/dorms/${id}`)
        .then(response => {
           // self.logo = response.data[0].logo
            // let dorm = response.data.find(function (dorm) { return dorm.id == window.localStorage.getItem('dorm_id') } )
            this.dorm = response.data
            this.images = response.data.images
            this.type_id = repnose.data.dorm_type_id
            this.phone = response.data.dorm.phone
            this.email = response.data.dorm.email
            window.localStorage.setItem('city_name',response.data.city.name)
            window.localStorage.setItem('district_name',response.data.district.name)

            if(response.data.is_wifi === '1') {
                window.localStorage.setItem('is_wifi','Wifi Var')
            } else {
                window.localStorage.setItem('is_wifi','Wifi Yok')
            }
            if(response.data.meal === '1') {
                window.localStorage.setItem('meal','1 Öğün')
            } else if (response.data.meal === '2') {
                window.localStorage.setItem('meal','2 Öğün')
            } else if (response.data.meal === '3') {
                window.localStorage.setItem('meal','3 Öğün')
            }
            if(response.data.type_id === '1') {
                window.localStorage.setItem('gender_name','Erkek Öğrenci Yurdu')
            } else {
                window.localStorage.setItem('gender_name','Kız Öğrenci Yurdu')
            }                         
                response.data.properties.forEach(item => {

                self.bina.forEach(item2 => {
                    if(item2.id === item.id) {
                item2.selected = true
                    }
                  })
                self.oda.forEach(item2 => {
                    if(item2.id === item.id) {
                item2.selected = true
                    }
                  })
                self.hizmetler.forEach(item2 => {
                    if(item2.id === item.id) {
                item2.selected = true
                    }
                  })                                    
              })

/*             //this.type_id = dorm.type_id
            self.city_id = dorm.city.id
            self.district_id = dorm.district.id
            self.name = dorm.name
            self.address = dorm.address
            self.phone = dorm.phone
            self.web = dorm.web */
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      
    getDormData() {
        
    },
    closeModal2() {
      this.showSuccessMessage = false
    },
    closeModal3() {
      this.showErrorMessage = false
    }, 
    validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
    },    
    saveDorm () {
      const mytoken = window.localStorage.getItem('access_token')
      this.slug = this.slugify(this.name)
      let self = this
      this.falseEmail = false
      this.emptyName = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName2 = false
      this.falsePhone2 = false
      this.shortPhone2 = false
      this.emptyName3 = false
      this.falsePhone3 = false
      this.shortPhone3 = false             
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyAddress = false
      this.emptyCapacity = false
      this.emptyMeal = false
      this.emptyWifi = false
      const verifiedMail = this.validateEmail(this.dorm.email)

      if(!this.dorm.email) {
        this.emptyEmail = true
      } else if(this.email &&! verifiedMail) {
        this.falseEmail = true
      }
      if(!this.dorm.name) {
        this.emptyName = true
      }
      if(!this.dorm.address) {
        this.emptyAddress = true
      }      
      if(!this.dorm.capacity) {
        this.emptyCapacity = true
      }
/*       if(!this.meal) {
        this.emptyMeal = true
      } */
      if(!this.dorm.is_wifi) {
        this.emptyWifi = true
      }
      if(!this.dorm.message_phone) {
        this.emptyPhone = true
      }      
      if(this.dorm.message_phone && !this.dorm.message_phone.startsWith("0")) {
        this.falsePhone = true
      }      

      if(this.dorm.message_phone && !this.falsePhone && this.dorm.message_phone.length != 11) {
        this.shortPhone = true
      }

      if(!this.dorm.phone) {
        this.emptyPhone2 = true
      }      
      if(this.dorm.phone && !this.dorm.phone.startsWith("0")) {
        this.falsePhone2 = true
      }      

      if(this.dorm.phone && !this.falsePhone2 && this.dorm.phone.length != 11) {
        this.shortPhone2 = true
      }
      if(!this.dorm.mobile_phone) {
        this.emptyPhone3 = true
      } 
      if(this.dorm.mobile_phone && !this.dorm.mobile_phone.startsWith("0")) {
        this.falsePhone3 = true
      }      

      if(this.dorm.mobile_phone && !this.falsePhone3 && this.dorm.mobile_phone.length != 11) {
        this.shortPhone3 = true
      }

if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyPhone2 && !this.falsePhone2 && !this.shortPhone2 && !this.emptyPhone3 && !this.falsePhone3 && !this.shortPhone3 && !this.emptyAddress && !this.emptyCapacity && !this.emptyMeal && !this.emptyWifi) {
      

/*       for (let i = 0; i < this.props.length; i++) {
        formData.append("props[]", this.props[i]);
      } */


/*      

      if(this.props.length > 0) {
        for (let i = 0; i < this.props.length; i++) {
          formData.append("props[]", this.props[i]);
        }
      } */

            var data = {
            type_id: self.dorm.dorm_type_id,
            city_id: this.dorm.city.id,
            district_id: this.dorm.district.id,
            name: this.dorm.name, //required',
            slug: this.dorm.slug, //required',
            keywords: this.dorm.keywords,
            description: this.dorm.description,
            member: this.dorm.member,
            capacity: this.dorm.capacity,
            is_wifi: this.dorm.is_wifi, //undefined',
            meal: this.dorm.meal, //undefined',
            content: this.dorm.content,// undefined',
            content_en: this.dorm.content_en, //undefined',
            facilities: '', //undefined',
            advantages: '', //undefined',
            events:'', //undefined',
            transportation: '', //undefined',
            other: '', //undefined',
            phone: this.dorm.phone, //regex:/(0)[0-9]{10}/|not_in:null,undefined',
            mobile_phone: this.dorm.mobile_phone, //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            message_phone: this.dorm.message_phone, //required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
            fax: self.fax,
            email: this.dorm.email,
            web: this.dorm.web, //undefined',
            address: this.dorm.address, //' => 'required|not_in:null,undefined',
            lat: this.dorm.lat, //undefined',
            lng: this.dorm.lng, //undefined',
            note: this.dorm.note, //undefined',
            }
            const formData = new FormData()
                Object.keys(data).map(e => {
                    formData.append(e, data[e]);
                })
          if(this.images.length > 0) {
          for (let i = 0; i < this.images.length; i++) {
            formData.append("images[]", this.images[i]);
          }
          }
         for (let i = 0; i < this.bina.length; i++) {
          if(this.bina[i].selected){
            formData.append("props[]", this.bina[i].id);
          }
        }
        for (let i = 0; i < this.oda.length; i++) {
          if(this.oda[i].selected){
            formData.append("props[]", this.oda[i].id);
          }
        }
        for (let i = 0; i < this.hizmetler.length; i++) {
          if(this.hizmetler[i].selected){
            formData.append("props[]", this.hizmetler[i].id);
          }
        }
      
      this.messageEnabled = false 
      axios.put("/dorm/dorms/", formData)
        .then(response => {
            if (response.status === 200 || response.status === 201) {
          self.messageEnabled = true
          self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
              self.messageEnabled = true
            }
        })
        .catch(e => {
          this.errors.push(e)
        })
}
    },
    getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectCity (opt) {
      this.city_id = opt.id
      this.districtEnabled = true
      let self = this
      axios.get(`/site/cities/${opt.slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
        .catch(e => {
          this.errors.push(e)
        }) 
    },
     selectDistrict(opt) {
       this.dorm.district_id = opt.id
     },
     selectGender(opt) {
       this.dorm.type_id = opt.id
     },
     selectWifi(opt) {
       this.dorm.is_wifi = opt.id
     },
     selectMeal(opt) {
       this.dorm.meal = opt.name
     },
     slugify(string) {
      const a = 'àáäâãåăæąçćčđèéėëêęǵḧìíïîįłḿǹńňñòóöôœøṕŕřßśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
     const b = 'aaaaaaaaacccdeeeeeeghiiiiilmnnnnooooooprrssssttuuuuuuuuuwxyyzzz------'
     const p = new RegExp(a.split('').join('|'), 'g')

     return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}       
  },
  created () {
    this.dorm_id = window.localStorage.getItem('dorm_id')
    this.mail = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
    this.getCities()
    this.getDorms()
  } 
}

</script>
<style lang="scss">

  @import "../assets/scss/components/dormAdd";
  @import "../assets/scss/components/dorm-branch";

  .mywidth {
    width: 5px;
  }

</style>
